import React, { useState } from 'react';
import { I } from '@/lib/icons';
import { useToast } from '@/components/Toast';

export default function SidebarSearch() {
  const toast = useToast();
  const [q, setQ] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!q.trim()) return;
    toast.show?.(`Hľadanie zatiaľ neimplementované — pripravujeme.`);
  };

  return (
    <form onSubmit={handleSubmit} role="search" style={{ width: '100%' }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: 8,
        padding: '8px 10px', borderRadius: 'var(--r-md)',
        background: 'var(--bg-surface)', border: '1px solid var(--border)',
      }}>
        <span style={{ color: 'var(--text-muted)', display: 'flex' }}>
          <I.search />
        </span>
        <input
          type="search"
          value={q}
          onChange={e => setQ(e.target.value)}
          placeholder="Hľadať FA, klienta, výdavok..."
          data-testid="sidebar-search-input"
          style={{
            flex: 1, minWidth: 0, border: 'none', outline: 'none', background: 'transparent',
            fontSize: 12.5, fontFamily: 'inherit', color: 'var(--text-primary)',
          }}
        />
      </div>
    </form>
  );
}
